








import Component, { mixins } from 'vue-class-component';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import LanguageSwitcherItem from '@/webcomponents/header/LanguageSwitcherItem.vue';
import ParentComponentMixin from '../../common/ts/child-component/ParentComponentMixin';

@Component
export default class LanguageSwitcher extends mixins(ParentComponentMixin) {
  items: ChildComponentCollection<LanguageSwitcherItem> = new ChildComponentCollection<LanguageSwitcherItem>();

  created () {
    this.initParentComponentMixin(
      this.items,
      ['LanguageSwitcherItem'],
    );
  }
}
